import { createSlice } from '@reduxjs/toolkit';

import { getFeaturedBlogsAPI } from '../actions/CustomerBlogAction';

interface CustomerBlogState {
  featuredBlogs: any[];
  categories: any[];
  authors: any[];
  advertisements: any;
  featuredLoading: boolean;
  categoriesLoading: boolean;
}

const initialState: CustomerBlogState = {
  featuredBlogs: [],
  categories: [],
  authors: [],
  advertisements: null,
  featuredLoading: false,
  categoriesLoading: false,
};

export const CustomerBlogSlice = createSlice({
  name: 'customerBlog',
  initialState,
  reducers: {
    resetCustomerBlogState() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFeaturedBlogsAPI.pending, (state) => {
        state.featuredLoading = true;
        state.categoriesLoading = true;
      })
      .addCase(getFeaturedBlogsAPI.fulfilled, (state, action) => {
        state.featuredLoading = false;
        state.featuredBlogs = action.payload?.featured_blogs || [];
        state.categories = action.payload?.categories || state.categories;
        state.authors = action.payload?.authors || state.authors;
        state.advertisements = action.payload?.advertisements ?? state.advertisements;
        state.categoriesLoading = false;
      })
      .addCase(getFeaturedBlogsAPI.rejected, (state) => {
        state.featuredLoading = false;
        state.categoriesLoading = false;
      });
  },
});

export const { resetCustomerBlogState } = CustomerBlogSlice.actions;
export default CustomerBlogSlice.reducer;
